export const Marquee = ({ items }) => {
  const row = [...items, "ROOTS", ...items, "ROOTS"];
  return (
    <div className="marquee py-6" style={{ borderTop: "1px solid rgba(217,218,221,0.15)", borderBottom: "1px solid rgba(217,218,221,0.15)" }} data-testid="marquee" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {row.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="font-head uppercase" style={{ fontSize: 30, letterSpacing: "0.08em", color: t === "ROOTS" ? "var(--bordeaux)" : "var(--platinum)", filter: t === "ROOTS" ? "brightness(1.9)" : "none", padding: "0 28px" }}>{t}</span>
                <span style={{ width: 6, height: 6, background: "var(--platinum)", borderRadius: 999, opacity: 0.6 }} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
